<div class="d-flex align-items-center">
    <form-field-material-switch class="mt-3 pr-3"
                                name="{{prefixName}}_add_page_assist"
                                [(ngModel)]="settingEnabled"
                                (ngChange)="onEnabledChange()">
    </form-field-material-switch>
    <label for="{{prefixName}}_add_page_assist" class="font-weight-400 my-0" translate>
        Add PageAssist script
    </label>
</div>

<form-domain-script-guide-legacy-page-assist-settings *ngIf="canUseFeature() && settingEnabled"
                                                      prefixName="{{prefixName}}"
                                                      [pageAssistModel]="pageAssistModel">
</form-domain-script-guide-legacy-page-assist-settings>
